import { z } from "zod";

import { machineAlarm } from "./machine-alarm";

export const machineStopReasonV2Schema = machineAlarm.extend({
	isError: z.boolean(),
});
